var _circle, _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_137_25221)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 16.145C6.25 13.9583 6.25 11.7687 6.25 9.58201C6.32024 9.37646 6.5157 9.31092 6.69894 9.44498C6.91577 9.59989 7.11123 9.77863 7.31585 9.94844C7.93581 10.4668 8.55882 10.9792 9.18184 11.4976C9.80791 12.0189 10.434 12.5432 11.057 13.0705C11.3044 13.2821 11.5517 13.4936 11.8022 13.7021C12.2267 14.0507 12.7581 14.0566 13.1795 13.7021C13.8453 13.145 14.5019 12.579 15.1707 12.0249C15.806 11.4946 16.4443 10.9673 17.0825 10.437C17.4399 10.1391 17.8033 9.84417 18.1575 9.54329C18.2553 9.45987 18.353 9.37646 18.4996 9.38837C18.6401 9.40029 18.7256 9.47477 18.7409 9.60883C18.747 9.64755 18.7439 9.68926 18.7439 9.72799C18.7439 11.8163 18.7348 13.9047 18.75 15.993C18.7561 16.6723 18.2186 17.0893 17.6231 17.0893C14.8317 17.0834 12.0404 17.0864 9.24903 17.0864C8.60769 17.0864 7.96635 17.0923 7.32195 17.0834C6.87607 17.0774 6.53708 16.8838 6.32635 16.4935C6.26832 16.3803 6.27443 16.2611 6.25 16.145Z",
    fill: "#003B6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4962 7.9165C14.2095 7.9165 15.9258 7.9165 17.6391 7.9165C17.9598 7.9165 18.2346 8.01779 18.4545 8.25016C18.6072 8.41103 18.598 8.55403 18.424 8.69703C17.0985 9.79929 15.77 10.8986 14.4446 12.0038C13.9285 12.4328 13.4185 12.8707 12.9085 13.3057C12.6031 13.5649 12.374 13.5649 12.0717 13.3057C10.2606 11.7506 8.41297 10.2402 6.57752 8.71192C6.37901 8.54509 6.36985 8.40508 6.55309 8.22335C6.76993 8.00886 7.03562 7.9165 7.34102 7.9165C9.06042 7.91948 10.7798 7.9165 12.4962 7.9165Z",
    fill: "#003B6F"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.75,
    y: 8.4165,
    width: 11.5,
    height: 8.16667,
    rx: 1.5,
    stroke: "#003B6F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_25221"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 7.9165,
    width: 12.5,
    height: 9.16667,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail-icon.e50c9cd8851e7a8b599ae5896759313b.svg";
export { ForwardRef as ReactComponent };